const miniData1 = [{
  value: 352,
  detail: 'Total Employee'
},
{
  value: 27,
  detail: 'New Employee'
},
{
  value: '80%',
  detail:'Happiness Rate'
},
{
  value: 5,
  detail:'Employee On Leave'
}]
const miniData2 = [{
  value: 40,
  detail: 'POLICIES'
},
{
  value: 50,
  detail: 'CLIENTS'
},
{
  value: 60,
  detail:'TEAMS'
},
{
  value: 20,
  detail:'DEPARTMENTS'
}]
export {miniData1, miniData2}